// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./NaplexPrep.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ptcb-prep .naplex-prep-glow-1 {
  background: var(--dlc-ptcb);
}

.ptcb-prep .naplex-prep-glow-2 {
  background: var(--dlc-ptcb-hover);
}

.ptcb-prep .naplex-prep-glow-3 {
  background: var(--dlc-ptcb);
}

.ptcb-prep .naplex-prep-badge {
  background: rgba(var(--dlc-ptcb-rgb), 0.12);
  border-color: rgba(var(--dlc-ptcb-rgb), 0.3);
  color: var(--dlc-ptcb);
}

.ptcb-prep .naplex-prep-hero h1 {
  filter: drop-shadow(0 0 60px rgba(var(--dlc-ptcb-rgb), 0.18));
}

.ptcb-prep .naplex-prep-hero h1 span {
  background: linear-gradient(135deg, var(--dlc-ptcb-hover), var(--dlc-ptcb), var(--dlc-ptcb-hover));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.ptcb-prep .naplex-prep-btn-primary {
  background: rgba(var(--dlc-ptcb-rgb), 0.15);
  border-color: rgba(var(--dlc-ptcb-rgb), 0.4);
  color: var(--dlc-ptcb);
}

.ptcb-prep .naplex-prep-btn-primary:hover {
  background: rgba(var(--dlc-ptcb-rgb), 0.24);
  border-color: rgba(var(--dlc-ptcb-rgb), 0.58);
  box-shadow: 0 4px 20px rgba(var(--dlc-ptcb-rgb), 0.22);
}

.ptcb-prep .naplex-prep-stat-value {
  color: var(--dlc-ptcb);
}

.ptcb-prep .naplex-prep-flow-num--2 {
  background: rgba(var(--dlc-ptcb-rgb), 0.15);
  color: var(--dlc-ptcb-hover);
  border-color: rgba(var(--dlc-ptcb-rgb), 0.3);
}

.ptcb-prep .naplex-prep-flow-num--3 {
  background: rgba(var(--dlc-ptcb-rgb), 0.15);
  color: var(--dlc-ptcb);
  border-color: rgba(var(--dlc-ptcb-rgb), 0.3);
}

.ptcb-prep .naplex-prep-area-card--totals {
  background: rgba(var(--dlc-ptcb-rgb), 0.06);
  border-color: rgba(var(--dlc-ptcb-rgb), 0.2);
}

.ptcb-prep .naplex-prep-area-card--totals .naplex-prep-area-name {
  color: var(--dlc-ptcb);
}

.ptcb-prep .naplex-prep-area-card--totals .naplex-prep-area-node {
  background: rgba(var(--dlc-ptcb-rgb), 0.08);
  border-color: rgba(var(--dlc-ptcb-rgb), 0.16);
}

.ptcb-prep .naplex-prep-compare-card--us {
  border-color: rgba(var(--dlc-ptcb-rgb), 0.28);
}

.ptcb-prep .naplex-prep-compare-card--us .naplex-prep-compare-label {
  color: var(--dlc-ptcb);
}

.ptcb-prep .naplex-prep-compare-card--us .naplex-prep-compare-icon {
  color: var(--dlc-ptcb-hover);
}

.ptcb-prep .naplex-prep-price-amount {
  color: var(--dlc-ptcb);
}
`, "",{"version":3,"sources":["webpack://./src/pages/PtcbPrep.css"],"names":[],"mappings":"AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kGAAkG;EAClG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["@import './NaplexPrep.css';\n\n.ptcb-prep .naplex-prep-glow-1 {\n  background: var(--dlc-ptcb);\n}\n\n.ptcb-prep .naplex-prep-glow-2 {\n  background: var(--dlc-ptcb-hover);\n}\n\n.ptcb-prep .naplex-prep-glow-3 {\n  background: var(--dlc-ptcb);\n}\n\n.ptcb-prep .naplex-prep-badge {\n  background: rgba(var(--dlc-ptcb-rgb), 0.12);\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.3);\n  color: var(--dlc-ptcb);\n}\n\n.ptcb-prep .naplex-prep-hero h1 {\n  filter: drop-shadow(0 0 60px rgba(var(--dlc-ptcb-rgb), 0.18));\n}\n\n.ptcb-prep .naplex-prep-hero h1 span {\n  background: linear-gradient(135deg, var(--dlc-ptcb-hover), var(--dlc-ptcb), var(--dlc-ptcb-hover));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.ptcb-prep .naplex-prep-btn-primary {\n  background: rgba(var(--dlc-ptcb-rgb), 0.15);\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.4);\n  color: var(--dlc-ptcb);\n}\n\n.ptcb-prep .naplex-prep-btn-primary:hover {\n  background: rgba(var(--dlc-ptcb-rgb), 0.24);\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.58);\n  box-shadow: 0 4px 20px rgba(var(--dlc-ptcb-rgb), 0.22);\n}\n\n.ptcb-prep .naplex-prep-stat-value {\n  color: var(--dlc-ptcb);\n}\n\n.ptcb-prep .naplex-prep-flow-num--2 {\n  background: rgba(var(--dlc-ptcb-rgb), 0.15);\n  color: var(--dlc-ptcb-hover);\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.3);\n}\n\n.ptcb-prep .naplex-prep-flow-num--3 {\n  background: rgba(var(--dlc-ptcb-rgb), 0.15);\n  color: var(--dlc-ptcb);\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.3);\n}\n\n.ptcb-prep .naplex-prep-area-card--totals {\n  background: rgba(var(--dlc-ptcb-rgb), 0.06);\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.2);\n}\n\n.ptcb-prep .naplex-prep-area-card--totals .naplex-prep-area-name {\n  color: var(--dlc-ptcb);\n}\n\n.ptcb-prep .naplex-prep-area-card--totals .naplex-prep-area-node {\n  background: rgba(var(--dlc-ptcb-rgb), 0.08);\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.16);\n}\n\n.ptcb-prep .naplex-prep-compare-card--us {\n  border-color: rgba(var(--dlc-ptcb-rgb), 0.28);\n}\n\n.ptcb-prep .naplex-prep-compare-card--us .naplex-prep-compare-label {\n  color: var(--dlc-ptcb);\n}\n\n.ptcb-prep .naplex-prep-compare-card--us .naplex-prep-compare-icon {\n  color: var(--dlc-ptcb-hover);\n}\n\n.ptcb-prep .naplex-prep-price-amount {\n  color: var(--dlc-ptcb);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
